/** Which pop-out tab opens first, chosen per browser (CSE-7). Pure, so it is testable. */
export const DRAWER_SECTIONS = ['snapshot', 'why', 'performance', 'profile', 'activity'] as const;
export type DrawerSection = (typeof DRAWER_SECTIONS)[number];

export const DEFAULT_SECTION: DrawerSection = 'snapshot';
const KEY = 'sift.salesView.drawerDefaultTab';

export function readDefaultSection(): DrawerSection {
  try {
    const stored = window.localStorage.getItem(KEY);
    return (DRAWER_SECTIONS as readonly string[]).includes(stored ?? '')
      ? (stored as DrawerSection)
      : DEFAULT_SECTION;
  } catch {
    return DEFAULT_SECTION;
  }
}

export function writeDefaultSection(section: DrawerSection): void {
  try {
    window.localStorage.setItem(KEY, section);
  } catch {
    // Storage blocked (private mode): the choice simply does not persist.
  }
}
